import React, { useState } from "react";
import { connect } from "react-redux";
import { Spin, Input, DatePicker, Select, notification } from "antd";
import axios from "axios";
import { saveSearchValue } from "../../redux/actions/search";
import {
  setValueFilter,
  searchBangAdv,
} from "../../redux/actions/searchFilter";
import { useHistory } from "react-router-dom";
import { GetCapCha } from "../../services/search";
import ModalCapcha from "../../components/ModalCapcha";
import debounce from "lodash/debounce";
import moment from "moment";

import Cookies from "js-cookie";
import {BASE_URL} from "../../requests/APIConfig";
import ModalReCapcha from "../../components/ModelReCapcha";

const mapStateToProps = (state) => {
  return {
    searchFilter: state.searchFilterReducer,
  };
};

function DebounceSelect({ fetchOptions, debounceTimeout = 500, ...props }) {
  const [fetching, setFetching] = React.useState(false);
  const [options, setOptions] = React.useState([]);

  const fetchRef = React.useRef(0);
  const debounceFetcher = React.useMemo(() => {
    const loadOptions = (value) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;
      setOptions([]);
      setFetching(true);
      fetchOptions(value).then((newOptions) => {
        if (fetchId !== fetchRef.current) {
          return;
        }

        setOptions(newOptions);
        setFetching(false);
      });
    };

    return debounce(loadOptions, debounceTimeout);
  }, [fetchOptions, debounceTimeout]);
  return (
    <Select
      className="mt-1"
      labelInValue
      filterOption={false}
      onSearch={debounceFetcher}
      notFoundContent={fetching ? <Spin size="small" /> : null}
      options={options}
      showSearch
      allowClear
      {...props}
    />
  );
}

async function fetchUserList(username) {
  // const url = `https://apistaging.jbcert.vn/api/Search/GetDanhSachTruongHoc`;
  const url = `${BASE_URL}/api/Search/GetDanhSachTruongHoc`;
  return axios
    .get(url, {
      params: {
        tenDonVi: username,
        maximumReturn: 12,
      },
    })
    .then((res) => {
      if (res && res.data) {
        return res.data.map((ele) => ({
          label: `${ele?.tenDonVi}`,
          value: ele.donViId,
        }));
      }
      notification.error({
        description: "Đã có lỗi xảy ra!",
      });
    })
    .catch(() => {
      notification.error({
        description: "Đã có lỗi xảy ra!",
      });
    });
}

function FilterSpace({
  searchBangAdv,
  saveSearchValue,
  searchFilter,
  setValueFilter,
}) {
  const history = useHistory();
  // const [keyword, setKeyword] = useState("");
  const [loading, setLoading] = useState(false);

  const [image, setImage] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const onSearch = async () => {
    // if (!keyword) return;
    try {
      if (!Cookies.get("code")) {
        // const resData = await GetCapCha({
        //   width: 200,
        //   height: 80,
        // });
        // if (resData) {
        //   setImage(
        //     `data:image/jpeg;base64,${Buffer.from(
        //       resData.data,
        //       "binary"
        //     ).toString("base64")}`
        //   );
        //   setIsModalVisible(true);
        // }
        setIsModalVisible(true);
      } else {
        searchData(Cookies.get("code"));
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const searchData = async (captcha) => {
    try {
      setLoading(true);
      const res = await searchBangAdv({
        params: {
          keyword: searchFilter?.keyword,
          pageNum: 1,
          pageSize: 5,
          // captcha,
          hvt: searchFilter?.name,
          nam: searchFilter?.year,
          idtruong: searchFilter?.donViId?.value,
        },
        callback: () => {
          onSearch();
        },
      });
      setLoading(false);
      // Cookies.set("code", captcha);
      saveSearchValue({
        pageNum: 1,
        pageSize: 5,
        keyword: searchFilter?.keyword,
      });
      const search = new URLSearchParams({
        pageNum: 1,
        pageSize: 5,
        keyword: searchFilter?.keyword,
      }).toString();
      setIsModalVisible(false);
      history.push({
        pathname: "/main",
        search,
      });
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <div
      className="w-100 h-100 pt-3 pb-3 d-flex flex-column justify-content-between"
      style={{
        border: "1px solid #bfbfbf",
        borderRadius: 8,
      }}
    >
      <Spin spinning={loading}>
        <div className="row ml-2 mr-2">
          <div className="col-lg-6 col-xl-4 col-12 mb-1">
            <div style={{ height: 60 }}>
              <span style={{ fontSize: 14 }}>Họ và tên</span>
              <Input
                placeholder="Nhập họ và tên"
                className="mt-1"
                value={searchFilter?.name}
                onChange={(event) => {
                  setValueFilter({
                    name: event.target.value,
                  });
                }}
              />
            </div>
          </div>
          <div className="col-lg-6 col-xl-4 col-12 mb-1">
            <div style={{ height: 60 }}>
              <span style={{ fontSize: 14 }}>Năm tốt nghiệp</span>
              <DatePicker
                picker="year"
                style={{ width: "100%" }}
                allowClear={false}
                className="mt-1"
                locale={{
                  lang: {
                    locale: "en_US",
                    placeholder: "Chọn năm",
                    monthBeforeYear: true,
                  },
                }}
                onChange={(value) => {
                  setValueFilter({
                    year: value.format("YYYY"),
                  });
                }}
                value={
                  searchFilter?.year ? moment(searchFilter?.year, "YYYY") : null
                }
              />
            </div>
          </div>
          <div className="col-lg-6 col-xl-4 col-12 mb-1">
            <div style={{ height: 60 }}>
              <span style={{ fontSize: 14 }} className="mb-1">
                Chọn trường học
              </span>
              <DebounceSelect
                placeholder="Nhập tên trường"
                fetchOptions={fetchUserList}
                onChange={(newValue) => {
                  setValueFilter({
                    donViId: newValue,
                  });
                }}
                style={{
                  width: "100%",
                }}
                value={searchFilter?.donViId}
              />
            </div>
          </div>
        </div>
        {/* <div className="w-100 d-flex flex-row justify-content-center align-items-center">
          <Button
            type="primary"
            icon={<SearchIcon style={{ fontSize: 14 }} className="mr-1" />}
            className="d-flex flex-row justify-content-center align-items-center"
            onClick={() => {
              onSearch();
            }}
          >
            Tìm kiếm
          </Button>
        </div> */}

        {isModalVisible && (
          <ModalReCapcha
            setIsModalVisible={setIsModalVisible}
            isModalVisible={isModalVisible}
          />
        )}
        {/*{isModalVisible ? (*/}
        {/*  <ModalCapcha*/}
        {/*    image={image}*/}
        {/*    setIsModalVisible={setIsModalVisible}*/}
        {/*    isModalVisible={isModalVisible}*/}
        {/*    callback={searchData}*/}
        {/*    setImage={setImage}*/}
        {/*  />*/}
        {/*) : null}*/}
      </Spin>
    </div>
  );
}

export default connect(mapStateToProps, {
  searchBangAdv,
  saveSearchValue,
  setValueFilter,
})(FilterSpace);
